import { call, put } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";
import { Auth } from "aws-amplify";

import { authnzForgotPasswordReset } from "../../actions";

import * as MiniMessageBox from "../../../../MiniMessageBox";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* authnzForgotPassword(email_address: string): Generator<any, any, any> {
  return yield Auth.forgotPassword(email_address);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzForgotPasswordWorker({ payload, navigate }: Record<string, any>): Generator<any, any, any> {
  const form = "ForgotPasswordForm";

  try {
    yield put(startSubmit(form));

    const { email_address } = payload;

    yield call(authnzForgotPassword, email_address);

    yield put(MiniMessageBox.hideMiniBoxMessage());
    yield put(stopSubmit(form));
    yield put(authnzForgotPasswordReset(navigate));
  } catch (error) {
    yield put(stopSubmit(form));
    if (error instanceof Error) {
      yield put(
        MiniMessageBox.showMiniBoxMessage({
          show: true,
          type: "error",
          message: error.message,
        }),
      );
    }
  }
}
